export default __webpack_public_path__ + "static/media/seg.47d7ea6b.webp";